import React from 'react';
import { useSelector } from 'react-redux';

import { Box, Grid, ThemeProvider } from '@material-ui/core';
import clsx from 'clsx';
import ContinueVerificationScreen from 'components/ThemeEditor/DesktopThemeEditor/components/MedallionPreview/MedallionScreens/ContinueVerificationScreen';
import TwoFAScreen from 'components/ThemeEditor/DesktopThemeEditor/components/MedallionPreview/MedallionScreens/TwoFAScreen';
import VerificationOptionsScreen from 'components/ThemeEditor/DesktopThemeEditor/components/MedallionPreview/MedallionScreens/VerificationOptionsScreen';
import VerifyIdentityScreen from 'components/ThemeEditor/DesktopThemeEditor/components/MedallionPreview/MedallionScreens/VerifyIdentityScreen';
import useMuiTheme from 'hooks/useMuiTheme';
import PropTypes from 'prop-types';

import styles from './workflowThemePreview.module.css';

/**
 * Theme preview was used zoom(https://developer.mozilla.org/en-US/docs/Web/CSS/zoom) property of css to scale down the preview screens.
 * The zoom property is widely supported in all browsers, but it is not supported in all browsers (like safari) so we are using the transform property instead.
 * Transform property does not recalculate the original size of element and leaves the white space
 * Here some inline style used to position the screens and make them dynamic
 */

const PREVIEW_SCREEN_WIDTH = '249.27px';
function WorkflowThemePreview({ workflowData, previewScreens = 2, className = '' }) {
    const themeData = useSelector((state) => state?.themeEditor);
    const theme = useMuiTheme(workflowData?.verify_ui_config?.theme || themeData);
    const themeLogo = workflowData?.verify_ui_config;

    const medallionPreviewScreens = [
        <VerifyIdentityScreen
            key="verify"
            button={theme.button}
            themeLogo={themeLogo}
            customScreenStyle={styles.previewScreens}
            style={{ top: '0px', left: '0px' }}
        />,
        <TwoFAScreen
            key="2fa"
            themeLogo={themeLogo}
            theme={theme}
            customScreenStyle={styles.previewScreens}
            style={{ top: '0px', left: `calc(100% / ${previewScreens}) ` }}
        />,
        <VerificationOptionsScreen
            key="options"
            themeLogo={themeLogo}
            theme={theme}
            customScreenStyle={styles.previewScreens}
            style={{ top: '0px', left: `calc(100% / ${previewScreens} * 2 )` }}
        />,
        <ContinueVerificationScreen
            key="continue"
            theme={theme}
            button={theme.button}
            textInputVariant={theme.textInputVariant}
            themeLogo={themeLogo}
            customScreenStyle={styles.previewScreens}
            style={{ top: '0px', left: `calc(100% / ${previewScreens} * 3 )` }}
        />,
    ];

    return (
        <Box className={clsx(styles.previewBox, className)}>
            <ThemeProvider theme={theme}>
                <Grid className={styles.mainSection} style={{ background: theme.overlayColor }}>
                    <Box
                        className={styles.previewScreensContainer}
                        // decide container width based on the number of screens and the width of the screen and add padding according to it
                        style={{
                            width: `calc(${PREVIEW_SCREEN_WIDTH} * 0.4 * ${previewScreens} + (32px * ${previewScreens}))`,
                        }}
                    >
                        {medallionPreviewScreens.slice(0, previewScreens)}
                    </Box>
                </Grid>
            </ThemeProvider>
        </Box>
    );
}

WorkflowThemePreview.propTypes = {
    previewScreens: PropTypes.number,
    workflowData: PropTypes.object,
    className: PropTypes.string,
};

export default WorkflowThemePreview;
